import { getFileLink } from "util/s3";

// "3 minutes ago" style label for a notification timestamp.
export const formatElapsedTime = (createdAt, now = Date.now()) => {
  const deltaSeconds = Math.max(
    0,
    Math.floor((now - new Date(createdAt).getTime()) / 1000)
  );
  const deltaMinutes = Math.floor(deltaSeconds / 60);
  const deltaHours = Math.floor(deltaMinutes / 60);
  const deltaDays = Math.floor(deltaHours / 24);

  const plural = (n, unit) => `${n} ${unit}${n === 1 ? "" : "s"} ago`;
  if (deltaDays > 0) return plural(deltaDays, "day");
  if (deltaHours > 0) return plural(deltaHours, "hour");
  if (deltaMinutes > 0) return plural(deltaMinutes, "minute");
  return "Just now";
};

const byNewest = (a, b) => new Date(b.createdAt) - new Date(a.createdAt);

// Shape raw notification rows (from the API or a socket push) for the header:
// drop the ones the current user sent, resolve the sender's avatar to a signed
// URL, stamp the "x ago" label and sort newest first. Every entry point goes
// through here so the list always has the same shape.
export const normalizeNotifications = async (items, currentUserId) => {
  const rows = (items || []).filter(
    (item) => item && item.senderId !== currentUserId
  );

  const list = await Promise.all(
    rows.map(async (item) => {
      let sender = item.sender;
      if (sender && sender.media && sender.media.url) {
        try {
          sender = {
            ...sender,
            media: { ...sender.media, url: await getFileLink(sender.media.url) },
          };
        } catch (err) {
          console.error(err);
        }
      }
      return {
        ...item,
        sender,
        elapsedTime: formatElapsedTime(item.createdAt),
      };
    })
  );

  return list.sort(byNewest);
};

// Insert a freshly-pushed notification into the current list, replacing any
// existing copy with the same id, so a re-delivered event never doubles up.
export const mergeNotification = (list, item) =>
  [item, ...(list || []).filter((n) => n.id !== item.id)].sort(byNewest);

// Number of notifications the bell badge should show.
export const countUnread = (list) =>
  (list || []).filter((n) => n.status === "UNREAD").length;
